import { RouteConfig } from "vue-router";
import { mainRoute, InjectRoutes } from "@/router";
import { layoutHelper } from '@/helpers/LayoutHelper';

const routes: Array<RouteConfig> = [
  {
    path: "areeOmogenee",
    name: "areeOmogenee",
    component: () => layoutHelper.isWeb ? import("./components/web/index-web.vue") : import("./components/mobile/index-mobile.vue"),
    meta: { title: "Aree Omogenee", showExpander: false, requireAuth: true }
  },
];

export default routes;